import { createStore } from '@shared/store';
import { UserDetailsType } from '@shared/types';
import {
  ServiceLocationDetailsObjectType,
  BinaryOptionsType,
  PublicLightingElectricVehicleChargers,
} from '@types';

type ServiceLocationDetailsType = ServiceLocationDetailsObjectType & {
  additional_details?: string;
};

export type EVChargerIssueType =
  | 'WiresExposed'
  | 'Damaged'
  | 'FailToStart'
  | 'OutOfService'
  | 'AppError'
  | 'LabelMissing'
  | 'SomethingElse'
  | '';

export type ProviderType = 'ESB' | 'ShellUbitricity' | 'SourceLondon';

const initialData = {
  uploadedImages: [],
  uploadedImagesFileName: [],
  uploadedImagesFileType: [],
  uploadedImagesBlob: [],
  serviceLocationDetails: [] as unknown as ServiceLocationDetailsType,
  assetDetails: null,
  fileWithLoadedCoordinates: '',
  isPhotoLocationStored: false,
  issueLocationMoreInfo: '',
  wantConfirmationEmail: '' as BinaryOptionsType,
  caseReferenceId: '',
  slaText: '',
  userDetails: {
    firstName: '',
    lastName: '',
    email: '',
    contactId: '',
  },
  sessionId: '',
  issueType: '' as EVChargerIssueType,
  provider: '' as ProviderType,
  isHazardous: '' as BinaryOptionsType,
  tellUsMoreDetails: '',
  fileDetailsObjects: [],
  issueLocationType: null,
};

interface EVChargerStoreType {
  uploadedImages: string[];
  uploadedImagesFileName: string[];
  uploadedImagesFileType: string[];
  uploadedImagesBlob: {
    blob_uri: string;
    blob_endpoint: string;
    filename: string;
  }[];
  serviceLocationDetails: ServiceLocationDetailsType;
  assetDetails: PublicLightingElectricVehicleChargers | null;
  fileWithLoadedCoordinates: string;
  isPhotoLocationStored: boolean;
  issueLocationMoreInfo: string;
  wantConfirmationEmail: BinaryOptionsType;
  isHazardous: BinaryOptionsType;
  caseReferenceId: string;
  slaText: string;
  userDetails: UserDetailsType;
  sessionId: string;
  issueType: EVChargerIssueType;
  provider: ProviderType;
  tellUsMoreDetails: string;
  fileDetailsObjects: { name: string; path: string }[];
}

export const useEVChargerStore = createStore<EVChargerStoreType>({
  initialData,
  name: 'ev-charger-store',
  persist: true,
  enableDevTools: false,
});

/**
 * Function to reset user details
 * Note: use getState() to access Zustand store method outside of a React component
 * */
export const resetUserDetails = () => {
  useEVChargerStore.getState().resetSelective(['userDetails', 'sessionId']);
};

export const resetIssueDetails = () => {
  useEVChargerStore
    .getState()
    .resetSelective([
      'uploadedImages',
      'uploadedImagesFileName',
      'uploadedImagesFileType',
      'uploadedImagesBlob',
      'serviceLocationDetails',
      'fileWithLoadedCoordinates',
      'isPhotoLocationStored',
      'isHazardous',
      'issueLocationMoreInfo',
      'issueType',
      'provider',
      'tellUsMoreDetails',
    ]);
};

export const updateStoreByKey = (key: string, value: any) => {
  useEVChargerStore.getState().update(key as keyof EVChargerStoreType, value);
};
